/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/no-unknown-property */
export const MarkerIcons = {
    crticalStatic: 'noc-dashboard-critical-alarm-marker-icon',
    criticalGlowing: 'noc-dashboard-critical-alarm-marker-icon',
    crticalWithChargingInactive: 'noc-dashboard-critical-alarm-marker-icon-charging-inactive',
    criticalWithChargingActive: 'noc-dashboard-critical-alarm-marker-icon-charging-active',
    criticalGlowingWithChargingActive:'noc-dashboard-critical-alarm-marker-icon-charging-active',
    majorStatic: 'noc-dashboard-major-alarm-marker-icon',
    majorGlowing:'noc-dashboard-major-alarm-marker-icon',
    majorWithChargingInactive: 'noc-dashboard-major-alarm-marker-icon-charging-inactive',
    majorWithChargingActive: 'noc-dashboard-major-alarm-marker-icon-charging-active',
    majorGlowingWithChargingActive: 'noc-dashboard-major-alarm-marker-icon-charging-active',
    minorStatic:'noc-dashboard-minor-alarm-marker-icon',
    minorGlowing: 'noc-dashboard-minor-alarm-marker-icon',
    minorWithChargingInactive: 'noc-dashboard-minor-alarm-marker-icon-charging-inactive',
    minorWithChargingActive: 'noc-dashboard-minor-alarm-marker-icon-charging-active',
    minorGlowingWithChargingActive: 'noc-dashboard-minor-alarm-marker-icon-charging-active',
    normal:'noc-dashboard-healthy-charger-marker-icon',
    normalGlowing:'noc-dashboard-healthy-charger-marker-icon',
    normalWithChargingInactive: 'noc-dashboard-healthy-charger-marker-icon-charging-inactive',
    normalWithChargingActive: 'noc-dashboard-healthy-charger-marker-icon-charging-active',
    offline: 'noc-dashboard-offline-charger-marker-icon',
    offlineGlowing: 'noc-dashboard-offline-charger-marker-icon',
    offlineWithChargingInactive: 'noc-dashboard-offline-charger-marker-icon-charging-inactive'
}